import { Action, createReducer, on } from '@ngrx/store';
import { SystemSettingsActions } from './system-settings.actions';
import {
    SystemSettingsState
} from './system-settings.state';

const initialSystemSettingsValue: SystemSettingsState = {
    settings: {
        inspireNotificationActive: false,
        inspireNotificationText: ''
    }
};

// NgRX 8 syntax
const reducer = createReducer(
    initialSystemSettingsValue,
    on(SystemSettingsActions.getSystemSettingsSuccess, (state, settings) => ({
        ...state,
        settings
    }))
);

export function systemSettingsReducer(state: SystemSettingsState | undefined, action: Action): SystemSettingsState {
    return reducer(state, action);
}
